import { sprintsSlice } from './slice';

export const { setSelectedTasks, setDirty, resetDirty } = sprintsSlice.actions;
